module.exports = __webpack_public_path__ + "static/media/eth.86b356aa.png";